import axios from "../plugins/axios";
import _ from "lodash";

export const registerVisit = async (pagina = null, params = null) => {
  try {
    const currentPage = pagina || getCurrentRoute();
    const currentParams = params || getCurrentUrlParams();

    const response = await axios.post('/registerVisit', {
      pagina: currentPage,
      params: serializeParams(currentParams)
    });

    return response.data;
    
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
};

// Função para serializar os parâmetros corretamente
const serializeParams = (params) => {
  if (!params) return null;
  
  // Se já for string, retorna como está
  if (typeof params === 'string') return params;
  
  // Se for objeto, converte para JSON string
  if (typeof params === 'object' && params !== null) {
    return JSON.stringify(params);
  }
  
  // Para outros tipos, converte para string
  return String(params);
};

// Função para tratamento de erros do Axios
const handleAxiosError = (error) => {
  if (error.response) {
    const status = _.get(error, 'response.status');
    const message = _.get(error, 'response.data.message') || 'Erro no servidor';
    
    switch (status) {
      case 401:
        throw new Error('Não autorizado. Faça login novamente.');
      case 403:
        throw new Error('Acesso negado.');
      case 404:
        throw new Error('Endpoint não encontrado.');
      case 422:
        throw new Error('Dados inválidos: ' + message);
      case 500:
        throw new Error('Erro interno do servidor.');
      default:
        throw new Error(`Erro ${status}: ${message}`);
    }
  } else if (error.request) {
    throw new Error('Sem resposta do servidor. Verifique sua conexão.');
  } else {
    throw new Error('Erro na configuração da requisição: ' + error.message);
  }
};

// Captura a rota atual
const getCurrentRoute = () => {
  if (typeof window === 'undefined') return 'server-side';
  
  const path = window.location.pathname;
  if (path === '/') return 'home';
  
  return path
    .replace(/^\//, '')
    .replace(/\//g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '')
    .toLowerCase();
};

// Captura parâmetros da URL automaticamente
const getCurrentUrlParams = () => {
  if (typeof window === 'undefined') return null;
  
  const urlParams = new URLSearchParams(window.location.search);
  const params = {};
  
  for (const [key, value] of urlParams.entries()) {
    params[key] = value;
  }
  
  return Object.keys(params).length > 0 ? params : null;
};

// Captura informações completas da página
export const getPageInfo = () => {
  if (typeof window === 'undefined') return {};
  
  return {
    route: getCurrentRoute(),
    urlParams: getCurrentUrlParams(),
    fullPath: window.location.pathname + window.location.search,
    hash: window.location.hash || null,
    title: document.title || null
  };
};